import { render, staticRenderFns } from "./DealerWaitExplanation.vue?vue&type=template&id=b0d47f2c&scoped=true"
import script from "./DealerWaitExplanation.vue?vue&type=script&lang=js"
export * from "./DealerWaitExplanation.vue?vue&type=script&lang=js"
import style0 from "./DealerWaitExplanation.vue?vue&type=style&index=0&id=b0d47f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d47f2c",
  null
  
)

export default component.exports